import { ICellRendererParams } from 'ag-grid-community';
import { Box } from '@mui/material';
import { ColorStatusBox } from '../../../../../../../components/Form/ColorStatus/ColorStatus';

export interface IColorStatusRendererParams extends ICellRendererParams<unknown, string> {
  colorMapping: Record<string, string>;
}

export function ColorStatusRenderer(props: IColorStatusRendererParams) {
  const color = props.colorMapping[props.value ?? ''] ?? '';

  return (
    <Box display={'flex'} height={'100%'} alignItems={'center'}>
      <ColorStatusBox statusColor={color} />
    </Box>
  );
}
